module.exports = __webpack_public_path__ + "media/landing_page/tech-crunch-logo-21fddb27.svg";